import ApplicationService from "./ApplicationService";
import LocalStorageService from "./LocalStorageService";
import InsuranceQuotingService from "../calculator/InsuranceQuotingService";
import { computed } from "mobx";
import RenewalsService from "../reporting/RenewalsService";
import ClaimsService from "../reporting/ClaimsService";
import ReportsService from "../reporting/ReportsService";
import InsuranceMtaService from "../calculator/InsuranceMtaService";
import InsuranceRenewalService from "../calculator/InsuranceRenewalService";
import PostcodeLookupService from "../PostcodeLookupService";
import TabsService from "../ui/TabsService";
import PoliciesService from "../reporting/PoliciesService";
import QuotesService from "../reporting/QuotesService";
import ThankYouService from "../calculator/ThankYouService";
import RateFilesService from "../reporting/RateFilesService";
import InsuranceRateQuotingService from "../calculator/InsuranceRateQuotingService";
import PaymentService from "../PaymentService";
import CustomerPortalService from "../CustomerPortalService";
import ClaimDocumentService from "../ClaimDocumentService";

class ApplicationContext {
	constructor() {
		this.localStorageService = new LocalStorageService(this);
		this.applicationService = new ApplicationService(this);

		this.insuranceMtaService = new InsuranceMtaService(this);
		this.insuranceRenewalsService = new InsuranceRenewalService(this);
		this.insuranceQuotingService = new InsuranceQuotingService(this);
		this.thankYouService = new ThankYouService(this);

		this.postcodeLookupService = new PostcodeLookupService(this);
		this.paymentService = new PaymentService(this);
		this.customerPortalService = new CustomerPortalService(this);
		this.claimDocumentService = new ClaimDocumentService(this);

		this.reportsService = new ReportsService(this);
		this.renewalsService = new RenewalsService(this);
		this.claimsService = new ClaimsService(this);
		this.policiesService = new PoliciesService(this);
		this.quotesService = new QuotesService(this);

		this.rateFilesService = new RateFilesService(this);
		this.insuranceRateQuotingService = new InsuranceRateQuotingService(this);

		this.tabsService = new TabsService(this);
	}

	@computed
	get authToken() {
		return this.applicationService.oAuthData.access_token;
	}
}

const applicationContext = new ApplicationContext();

export { applicationContext };
